import { CustomRouter } from "@utils/router";
import { ErrorPage } from './error.page';
import { ErrorPageMessagePayload } from '@core/services/server-error';

export class ErrorRoutes {
    static register(router: typeof CustomRouter) {
        router.add('erro', (params: ErrorPageMessagePayload) => {
            const body = document.body;
            body.innerHTML = ErrorPage.render(params);
        });
    }
}
